import { render, staticRenderFns } from "./AppInitializer.vue?vue&type=template&id=07a4fdba&"
import script from "./AppInitializer.vue?vue&type=script&lang=js&"
export * from "./AppInitializer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VProgressCircular,VRow,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07a4fdba')) {
      api.createRecord('07a4fdba', component.options)
    } else {
      api.reload('07a4fdba', component.options)
    }
    module.hot.accept("./AppInitializer.vue?vue&type=template&id=07a4fdba&", function () {
      api.rerender('07a4fdba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/AppInitializer.vue"
export default component.exports